import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';

import { UserRegimenModule } from '../../../../user-regimen/user-regimen.module';
import { InstructionsService } from '@services/instructions-service/instructions.service';
import { ConnectionService } from '@services/connection-service';
import { GetUserInstructionDetails } from '@cureskin/api-client/src/server-api';
import { LoadingModule } from '@components/loading';
import { CsIconModule } from '@components/icon';
import { SwiperOptions } from 'swiper';
import { SwiperModule } from 'swiper_angular';

@Component({
  selector: 'user-products-view',
  standalone: true,
  imports: [UserRegimenModule, LoadingModule, CsIconModule, SwiperModule],
  templateUrl: './user-products-view.component.html',
})
export class UserProductsViewComponent implements OnInit, AfterViewInit {
  @ViewChild('swiperCardsBanner') swiperComponent: any;

  products: any[] = [];
  addOnInstructions: GetUserInstructionDetails['userInstructions']['ADDITIONAL_PRODUCTS'] = [];
  userInstructions: GetUserInstructionDetails | null;
  loading: boolean = false;
  showProductCarousalPopUp: boolean = false;
  selectedImageIndex: number = 0;
  carouselConfig: SwiperOptions = {
    initialSlide: this.selectedImageIndex,
    slidesPerView: 1.2,
    spaceBetween: 20,
    autoHeight: false,
    speed: 600,
    pagination: false,
    centeredSlides: true,
    navigation: false,
    autoplay: false,
  };

  constructor(
    private readonly instructionsService: InstructionsService,
    private readonly conn: ConnectionService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.userInstructions = this.instructionsService.getUserInstructions();
    // If no cached data fetch from API
    if (!this.userInstructions) {
      this.userInstructions = await this.conn.getInstructionsForUser();
      this.instructionsService.setUserInstructions(this.userInstructions);
    }
    this.addOnInstructions = this.instructionsService.getAddOnInstructions();
    this.products = this.addOnInstructions.map((instruction) => this.instructionsService.generateCommonDataForInstruction(instruction.PRODUCT));
    this.loading = false;
  }

  ngAfterViewInit(): void {
    if (this.swiperComponent?.swiper) {
      this.swiperComponent.swiper.update();
    }
  }

  back(): void {
    this.conn.navigateToURL('/regimen?tab=regimen&class=OTHERS')
  }

  openCarousalPopUp = (i: number): void => {
    this.selectedImageIndex = i;
    this.carouselConfig = { ...this.carouselConfig, initialSlide: this.selectedImageIndex };
    this.showProductCarousalPopUp = true;
    if (this.swiperComponent?.swiper) {
      this.swiperComponent.swiper.slideTo(this.selectedImageIndex, 0); // Slide to the selected index
      this.swiperComponent.swiper.update(); // Update the swiper instance
    }
  };

  closeCarousalPopUp = (): void => {
    this.showProductCarousalPopUp = false;
  };
}
